<div class="wizard-wrapper">
  <div
    class="wizard-header"
    *ngIf="showHeader"
  >
    <!-- Collected Payments Browser -->
    <div *ngIf="finalPayments.length > 1" class="payment-browser">
      <zlng-payment-browser></zlng-payment-browser>
    </div>

    <div class="nav-buttons">
      <ng-container *ngFor="let actionButton of actionButtons; index as i;">
        <jf-button
          [variant]="'ghost'"
          [icon]="actionButton.icon"
          [iconPosition]="'left'"
          routerLink="{{actionButton.href}}"
          [queryParams]="actionButton.queryParams"
          (doClick)="doLogout(actionButton.logout)"
        >
          {{ actionButton.title }}
        </jf-button>
        <div *ngIf="i+1 < actionButtons.length" class="divider"></div>
      </ng-container>
    </div>
  </div>

  <div class="wizard-left-content">
    <router-outlet name="left"></router-outlet>
  </div>

  <div class="wizard-right-content">
    <router-outlet name="right"></router-outlet>
  </div>
</div>
